import { Component, OnInit, Inject, DOCUMENT, ChangeDetectorRef } from "@angular/core";

import { NavService } from "../../services/nav.service";
import { LayoutService } from "../../services/layout.service";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";

SwiperCore.use([Navigation, Pagination, Autoplay]);
@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: false
})
export class HeaderComponent implements OnInit {
    public elem: any;
    version: string = "";
    constructor(
        public layout: LayoutService,
        public navServices: NavService,
        @Inject(DOCUMENT) private readonly document: any
    ) { }
    ngOnInit() {
        this.elem = document.documentElement;
        this.navServices.collapseSidebar = true;
        this.navServices.getVersion().subscribe({
            next: (response) => {
                console.log(response,"Version");
                if (response?.data) {
                    this.version = response.data.version;
                } else {
                    console.warn("Version not found in response!");
                }
            },
            error: (error) => {
                console.error("Error fetching version", error);
            }
        });
    }

    sidebarToggle() {
        this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
        this.navServices.megaMenu = true;
        this.navServices.levelMenu = true;
    }
    layoutToggle() {
        if (this.layout.config.settings.layout_version === "dark-only") {
            document.body.classList.toggle("dark-only");
        }
        document.body.remove();
    }

    searchToggle() {
        this.navServices.search = true;
    }

    languageToggle() {
        this.navServices.language = !this.navServices.language;
    }

    toggleFullScreen() {
        this.navServices.fullScreen = !this.navServices.fullScreen;
        if (this.navServices.fullScreen) {
            if (this.elem.requestFullscreen) {
                this.elem.requestFullscreen();
            } else if (this.elem.mozRequestFullScreen) {
                this.elem.mozRequestFullScreen();
            } else if (this.elem.webkitRequestFullscreen) {
                this.elem.webkitRequestFullscreen();
            } else if (this.elem.msRequestFullscreen) {
                this.elem.msRequestFullscreen();
            }
        }
        if (!this.navServices.fullScreen) {
            if (this.document.exitFullscreen) {
                this.document.exitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
                this.document.webkitExitFullscreen();
            } else if (this.document.msExitFullscreen) {
                this.document.msExitFullscreen();
            }
        }
    }
}
